// extracted by mini-css-extract-plugin
export var blink = "_7u-2";
export var cursor = "_7u-1";
export var reactMarkdown = "_7u-3";
export var streamingText = "_7u-0";